import { Input, Component } from '@angular/core';
import { LoadingScreenService } from './his-loading-screen.services';

@Component({
  standalone: false,
  selector: "his-loader",
  templateUrl: './his-loader.html',
  styleUrls: ['./../../../../public/themes/theme-default/loading.component.css']
})

export class LoaderComponent {
  @Input("loadingScreen")
  public showLoading: boolean = false;

  constructor(public loadingScreenService: LoadingScreenService) {

  }
}

